import { render, staticRenderFns } from "./sToolbarPerson.vue?vue&type=template&id=2fcb2034&"
import script from "./sToolbarPerson.vue?vue&type=script&lang=js&"
export * from "./sToolbarPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports